import Select from './select';
import { useAlert } from 'react-alert';
import { useCallback } from 'react';
import { useConfirmLocation } from '../../../util/misc';

const mapToOptions = (list: string[]) => list.map((name) => ({ name, value: name }));
const multilineText = (text: string) => text.split('\n').map((s, idx) => <p key={idx}>{s}</p>);
export default function NewIekLocationFilters({
    country,
    region,
    city,
    countries,
    regions,
    cities,
    setCountry,
    setRegion,
    setCity,
}: {
    country: string;
    region: string;
    city: string;
    countries: string[];
    regions: string[];
    cities: string[];
    setCountry: (v: string) => void;
    setRegion: (v: string) => void;
    setCity: (v: string) => void;
}) {
    const alert = useAlert();
    const alertMissing = useCallback(
        (text) => {
            const alertInstance = alert.show(multilineText(text), {
                // @ts-ignore
                title: 'Местоположение не определено',
                actions: [{ name: 'Ок', onClick: () => alertInstance.close() }],
                type: 'error',
            });
        },
        [alert]
    );
    const confirmLocation = useCallback(
        (text: string, callback: () => void) => {
            const alertInstance = alert.show(multilineText(text), {
                // @ts-ignore
                title: 'Ваше местоположение',
                actions: [
                    {
                        name: 'Да',
                        onClick: () => {
                            callback();
                            alertInstance.close();
                        },
                    },
                    {
                        name: 'Нет',
                        className: 'ui-button--gray',
                        onClick: () => alertInstance.close(),
                    },
                ],
            });
        },
        [alert]
    );

    useConfirmLocation(alertMissing, confirmLocation);

    return (
        <>
            <div className="partners-select-item">
                <Select
                    name="Страна"
                    value={country}
                    options={mapToOptions(countries)}
                    onChange={(v) => setCountry(v || '')}
                />
            </div>
            <div className="partners-select-item">
                <Select
                    name="Регион"
                    value={region}
                    options={mapToOptions(regions)}
                    onChange={(v) => setRegion(v || '')}
                />
            </div>
            <div className="partners-select-item">
                <Select
                    name="Населенный пункт"
                    value={city}
                    options={mapToOptions(cities)}
                    onChange={(v) => setCity(v || '')}
                />
            </div>
        </>
    );
}
